import React from 'react';
import { motion } from 'framer-motion';
import FadeIn from './shared/FadeIn';
import { HIGHLIGHTS, ARTICLES } from '../data/highlights';

const ICONS = {
  visa: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
      d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5a17.92 17.92 0 01-8.716-2.247m0 0A8.966 8.966 0 013 12c0-1.257.26-2.453.727-3.418" />
  ),
  book: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
      d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
  ),
  mic: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
      d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
  ),
  trophy: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
      d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M18.75 4.236c.982.143 1.954.317 2.916.52A6.003 6.003 0 0016.27 9.728M18.75 4.236V4.5c0 2.108-.966 3.99-2.48 5.228m0 0a6.023 6.023 0 01-3.77 1.522m3.77-1.522a6.023 6.023 0 003.77-1.522M7.73 9.728a6.023 6.023 0 003.77 1.522m0 0a6.023 6.023 0 003.77-1.522" />
  ),
  academic: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
      d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  ),
  cog: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
      d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
  ),
};

const HighlightIcon = ({ icon }) => {
  const path = ICONS[icon];
  if (!path) return null;
  return (
    <div className="w-9 h-9 rounded-lg bg-green/10 border border-green/20 flex items-center justify-center mb-3 shrink-0">
      <svg className="w-[18px] h-[18px] text-green" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        {path}
      </svg>
    </div>
  );
};

const HighlightCard = React.memo(({ item, index }) => {
  const cls =
    'border border-border rounded-xl p-5 bg-raised/60 hover:border-green/20 hover:bg-raised hover:shadow-xl hover:shadow-green/[0.03] transition-all duration-300 flex flex-col';

  const content = (
    <>
      <HighlightIcon icon={item.icon} />
      <h3 className="text-sm font-display font-semibold text-txt mb-1.5">{item.label}</h3>
      <p className="text-sm text-txt-secondary leading-relaxed flex-1">{item.detail}</p>
      {item.link && (
        <span className="text-xs text-green/60 mt-3 inline-flex items-center gap-1 group-hover:text-green transition-colors">
          Read more
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </span>
      )}
    </>
  );

  const motionProps = {
    initial: { opacity: 0, y: 16 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.4, delay: index * 0.06 },
  };

  return item.link ? (
    <motion.a
      href={item.link}
      target={item.link.startsWith('http') ? '_blank' : undefined}
      rel={item.link.startsWith('http') ? 'noopener noreferrer' : undefined}
      className={cls + ' group block'}
      {...motionProps}
    >
      {content}
      {item.link.startsWith('http') && <span className="sr-only"> (opens in new tab)</span>}
    </motion.a>
  ) : (
    <motion.div className={cls} {...motionProps}>
      {content}
    </motion.div>
  );
});

const Highlights = () => (
  <FadeIn id="highlights" className="py-28 bg-raised/30 content-auto">
    <div className="max-w-6xl mx-auto px-6">
      <div className="mb-12">
        <span className="text-xs font-mono text-green/50 tracking-widest mb-3 block" aria-hidden="true">04</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-3">Highlights & Writing</h2>
        <p className="text-txt-secondary text-lg">Achievements, publications, and media</p>
      </div>

      {/* Highlight cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
        {HIGHLIGHTS.map((item, i) => (
          <HighlightCard key={i} item={item} index={i} />
        ))}
      </div>

      {/* Articles */}
      <div className="max-w-3xl">
        <h3 className="font-display text-xl font-semibold mb-5 flex items-center gap-2">
          <span className="text-green/50 font-mono text-sm" aria-hidden="true">#</span>
          Articles & Media
        </h3>
        <div className="space-y-2">
          {ARTICLES.map((a, i) => (
            <motion.a
              key={i}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, x: -8 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
              className="flex items-center justify-between py-3 px-4 border border-border rounded-lg bg-raised/60 hover:border-green/20 hover:bg-raised transition-all duration-200 group"
            >
              <span className="text-sm text-txt group-hover:text-green transition-colors duration-200 min-w-0 line-clamp-2 sm:truncate">
                {a.title}
              </span>
              <span className="text-xs font-mono text-txt-tertiary shrink-0 ml-4 px-2 py-0.5 bg-subtle/50 rounded">
                {a.source}
              </span>
              <span className="sr-only"> (opens in new tab)</span>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  </FadeIn>
);

export default Highlights;
